import { gql, useMutation } from '@apollo/client';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const QUERY = gql`
  mutation VerifyToken($input: VerifyAccountInput!) {
    VerifyToken(input: $input)
  }
`;

const useVerifyAccount = () => {
  const [mutate, { loading }] = useMutation(QUERY, {
    client: subscriptionsPublicClient,
  });

  const verify = ({ phone, email, code }) => {
    let variables = {
      input: {
        phone,
        email,
        code,
      },
    };

    return mutate({ variables });
  };

  return { verify, loading };
};

export default useVerifyAccount;
